import {Message, Upload,} from 'element-ui';
import {SUCCESS, OVER_TIME,} from '../conf/response.code.conf';
import http from '../http';
import $router from '../router';
import resetMessage from '../components/resetMessage/resetMessage'

const stateMiddleWare = data => {
  switch (data.code) {
    case SUCCESS:
      data.status = true;
      return data;
    case OVER_TIME:
      data.status = false;
      // Message.warning(data.msg);
      resetMessage({
        type: 'error',
        message: data.msg,
      });
      // setTimeout(() => {
      //     $router.push('/login');
      // }, 2000);
      return data;
    default:
      data.status = false;
      return data;
  }
};

export default {
  async getU(url, params = {}) {
    try {
      const data = await http.getU(url, params);
      return stateMiddleWare(data);
    }
    catch (err) {
      return {
        code: '000000',
        err,
      };
    }
  },
  async post(url, params = {}) {
    try {
      let TOKEN = localStorage.TOKEN;
      //判断登录状态屏蔽请求
      let re = ['getEncryptInfo', 'login_erp', 'selectAuthorityByUserId', 'selectAuthorityByFunctionId','getCurrentGuest'].findIndex(v => url.indexOf(v) >= 0) >= 0;
      if (TOKEN || re) {
        const data = await http.post(url, params);
        return stateMiddleWare(data);
      }
    }
    catch (err) {
      return {
        code: '000000',
        err,
      };
    }
  },
  async upload(url, params = {}) {
    try {
      const data = await http.upload(url, params);
      return stateMiddleWare(data);
    }
    catch (err) {
      return {
        code: '000000',
        err,
      };
    }
  },
  async download(url, params = {}) {
    try {
      const data = await http.download(url, params);
      return data;
    }
    catch (err) {
      return {
        code: '000000',
        err,
      };
    }
  },
  async postJson(url, params = {}) {
    try {
      const data = await http.postJson(url, params);
      return stateMiddleWare(data);
    }
    catch (err) {
      return {
        code: '000000',
        err,
      };
    }
  },
  async setHeader({key, val,}) {
    await http.setHeader({
      key,
      val,
    });
  },
};
